import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useClientContact, ClientContact } from './useData';
import { moduleConfig } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<ClientContact>
      useData={useClientContact}
      config={moduleConfig}
    />
  );
};

export default Form;
